const codePush = () => (Component) => Component;

codePush.CheckFrequency = {
  ON_APP_START: 0,
  ON_APP_RESUME: 1,
  MANUAL: 2
};

codePush.InstallMode = {
  IMMEDIATE: 0,
  ON_NEXT_RESUME: 1,
  ON_NEXT_RESTART: 2
};

codePush.SyncStatus = {
  UP_TO_DATE: 0,
  UPDATE_INSTALLED: 1,
  UPDATE_IGNORED: 2,
  UNKNOWN_ERROR: 3,
  SYNC_IN_PROGRESS: 4,
  CHECKING_FOR_UPDATE: 5,
  AWAITING_USER_ACTION: 6,
  DOWNLOADING_PACKAGE: 7,
  INSTALLING_UPDATE: 8
};

codePush.sync = async () => codePush.SyncStatus.UP_TO_DATE;
codePush.checkForUpdate = async () => null;
codePush.getUpdateMetadata = async () => null;
codePush.clearUpdates = async () => undefined;
codePush.restartApp = () => {
  if (typeof window !== 'undefined') window.location.reload();
};

export default codePush;
